(() => {
  if (customElements.get('tos-halloween-carousel')) return;
  customElements.define('tos-halloween-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.controls = this.querySelector('.tos-campaign__controls');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.focused = false;
      this.controls.hidden = false;
      this.addEventListener('click', event => {
        const select = event.target.closest('[data-select]');
        if (select) this.show(Number(select.dataset.select));
        this.schedule();
      }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.schedule();
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.querySelectorAll('[data-select]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }

    schedule() {
      clearTimeout(this.timer);
      if (this.motion.matches || this.focused || document.hidden) return;
      this.timer = setTimeout(() => { this.show((this.index + 1) % this.slides.length); this.schedule(); }, 3000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.abort = null; }
  });
})();
